@if (!isLoading) {
  <div class="container period-selection-container">
    <div class="row" [ngClass]="{'invalid-value': isFieldInvalid('selectedReferenceFrameIndex')}">
      <div class="col col-12">
        <label for="referenceFrameSelect">Select Reference Period</label>
        <app-select2
          id="referenceFrameSelect"
          placeholder="Select"
          [data]="periodOptions"
          [options]="{minimumResultsForSearch: -1}"
          [value]="selectedReferenceFrameIndex"
          (valueChanged)="updateSelectedReferenceFrameIndex($event.value)"
          [width]="'100%'"
          >
        </app-select2>
        @if (getFieldError('selectedReferenceFrameIndex'); as errMsg) {
          <p class="invalid-value-warning">{{ errMsg }}</p>
        }
        @if (showPrefillReferencePeriodNotFoundError && !hasReferenceFrameBeenChangedByUser) {
          <div class="invalid-value-warning">
            The reference period for this forecast could not be found. It may have been modified or deleted. Please select a new reference period.
          </div>
        }
      </div>
    </div>
    <div class="row padding-bottom-4">
      <div class="col col-12">
        <p class="consolidate-periods-form-header">Select the line item(s) to apply growth or decay to. Amounts can be positive or negative. Enter percentages as full numbers. </p>
      </div>
    </div>
    <div class="row padding-bottom-0">
      <div class="col col-5">
        <label>Line Item(s)</label>
      </div>
      <div class="col col-7">
        <label>Amount</label>
      </div>
    </div>
    @for (item of lineItemsArray.controls; track lineItemTrackByIndex(i, item); let i = $index) {
      <div class="row padding-top-0">
        <div class="col col-5 line-item-input" [ngClass]="{'invalid-value': isLineItemControlInvalid(i, 'selectedTaxonomyItemId')}">
          <app-select2
            [id]="'taxonomyItemSelection' + i"
            placeholder="Select"
            [data]="lineItemTaxonomyOptions[i] ?? []"
            [value]="item.get('selectedTaxonomyItemId')?.value"
            (valueChanged)="updateSelectedTaxonomyItemId($event.value, i)"
            [width]="'100%'"
            >
          </app-select2>
          @if (getLineItemError(i, 'selectedTaxonomyItemId'); as errMsg) {
            <p class="invalid-value-warning">{{ errMsg }}</p>
          }
        </div>
        <div class="col col-6 line-item-input">
          <div class="input-group">
            <div class="input-group-addon">
              <select class="form-select" [id]="'growthTypeSelect' + i" (change)="updateGrowthType($event.target.value, i)">
                @for (growthTypeOption of growthTypeOptions; track growthTypeOption) {
                  <option [selected]="growthTypeOption.id == item.get('growthType')?.value"
                  [value]="growthTypeOption.id">{{growthTypeOption.text}}</option>
                }
              </select>
            </div>
            <input
              type="text"
              [id]="'growthValueSelect' + i"
              class="form-control"
              [ngClass]="{ 'danger-border': isLineItemControlInvalid(i, 'growthValue') }"
              [placeholder]="GROWTH_TYPE_TO_VALUE_PLACEHOLDER_TEXT_MAPPINGS[item.get('growthType')?.value]"
              [value]="item.get('growthValue')?.value"
              (input)="updateGrowthValue($event.target.value, i)"
              >
          </div>
          @if (getLineItemError(i, 'growthValue'); as errMsg) {
            <p class="invalid-value-warning">{{ errMsg }}</p>
          }
        </div>
        <div class="col col-1">
          <button class="btn btn-danger remove-item-btn" [ngClass]="{'disabled': lineItemsArray.length === 1}" [disabled]="lineItemsArray.length === 1" (click)="removeLineItem(i)"><i class="fas fa-trash"></i></button>
        </div>
      </div>
      <div class="col col-12" [ngClass]="{'invalid-value': getLineItemGrowthTypeInvalid(i)}">
        @if (getLineItemGrowthTypeInvalid(i)) {
          <p class="invalid-value-warning">Item is associated with a value in an adjustment section. Please only choose percentage growth rate.</p>
        }
      </div>
    }
    <div class="row padding-top-and-bottom-4">
      <div class="col col-12">
        <div class="btn btn-link add-line-item-button" (click)="addLineItem()"><i class="fas fa-plus"></i>Add Line Item</div>
      </div>
    </div>
    @if (selectedReferenceFrameIndex !== -1 && shouldAndCanCheckBalanceSheetBalance) {
      <div class="row">
        <div class="col col-12">
          @if (!(check < CHECK_THRESHOLD && check > -CHECK_THRESHOLD)) {
            <p class="balance-sheet-check wrong-balance"><i class="fas fa-warning"></i>Balance sheet check: <span id="check-balance">{{ numberFormattingService.formatNumber(check, "CURRENCY", 2, {'showDollarSign': true}) }}</span><span class="copy-balance" (click)="copyCheckToClipboard()">Copy</span></p>
          }
          @if (check < CHECK_THRESHOLD && check > -CHECK_THRESHOLD) {
            <p class="balance-sheet-check correct-balance"><i class="fas fa-check"></i>Balance sheet check: <span id="check-balance">{{ numberFormattingService.formatNumber(check, "CURRENCY", 2, {'showDollarSign': true}) }}</span></p>
          }
        </div>
      </div>
    }
    <div class="row padding-bottom-4">
      <div class="col col-12">
        <p class="add-consolidated-period-information-text">Add forecasted period information</p>
      </div>
    </div>
    <div class="row padding-bottom-4">
      <div class="col col-6 reporting-interval-select" [ngClass]="{'invalid-value': isFieldInvalid('reportingInterval')}">
        <label for="reportingInterval">Select Reporting Interval</label>
        <app-select2
          id="reportingIntervalSelect"
          placeholder="Select"
          [data]="reportingIntervalOptions"
          [options]="{minimumResultsForSearch: -1}"
          [value]="reportingInterval"
          (valueChanged)="updateReportingInterval($event.value)"
          [width]="'100%'"
          >
        </app-select2>
        @if (getFieldError('reportingInterval'); as errMsg) {
          <p class="invalid-value-warning">{{ errMsg }}</p>
        }
      </div>
      <div class="col col-6 statement-date-select"  [ngClass]="{'invalid-value': isFieldInvalid('statementDate')}">
        <label for="statementDate">Select Statement Date</label>
        <app-input-calendar-component
          [initialDate]="statementDate"
          (dateEmitter)="updateStatementDate($event)"
        ></app-input-calendar-component>
        @if (getFieldError('statementDate'); as errMsg) {
          <p class="invalid-value-warning">{{ errMsg }}</p>
        }
      </div>
    </div>
    <div class="row padding-bottom-4">
      <div class="col col-6 projection-name-select">
        <div class="form-group" [ngClass]="{'invalid-value': isFieldInvalid('scenarioType')}">
          <label for="scenarioType" class="control-label">Scenario Type</label>
          <app-select2
            id="scenarioTypeSelect"
            placeholder="Select"
            [data]="scenarioTypeOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="scenarioType"
            (valueChanged)="updateScenarioType($event.value)"
            [width]="'100%'"
            >
          </app-select2>
          @if (getFieldError('scenarioType'); as errMsg) {
            <p class="invalid-value-warning">{{ errMsg }}</p>
          }
        </div>
      </div>
      <div class= "col col-6 currency-select">
        <label for="currencySelect">Select Currency</label>
        <span class="ps-2">
          <i class="fas fa-circle-question" data-bs-toggle="tooltip" data-bs-placement="top"
            title="Use this to select the currency for this built statement. Note: Currencies will not be converted. If forecasting a
            period in a currency (e.g., USD) different than the reference period (e.g., CAD), amounts will be projected without conversion."></i>
        </span>
        <select class="form-select" (change)="changeCurrency($event.target.value)">
          @for (currencyOption of supportedCurrencies; track currencyOption) {
            <option [value]="currencyOption.key"
              [selected]="currencyOption.key === currency">
              {{currencyOption.key}} ({{currencyOption.symbol}})
            </option>
          }
        </select>
      </div>
    </div>
    <div class="row padding-bottom-4">
      <div class="col col-6 projection-name-select">
        <div class="form-group" [ngClass]="{'invalid-value': isFieldInvalid('projectionName')}">
          <label for="projectionName" class="control-label">Scenario Name</label>
          <input [value]="projectionName" type="text" id="projectionName" class="form-control" placeholder="Scenario Name" (input)="updateProjectionName($event.target.value)">
          @if (getFieldError('projectionName'); as errMsg) {
            <p class="invalid-value-warning">{{ errMsg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center footer">
      @if (hasAttemptedSubmit && hasFormErrors) {
        <span class="footer-error-message">Please resolve error(s)</span>
      }
      <div class="d-flex justify-content-end flex-grow-1 footer-action-buttons">
        <button class="btn btn-link" (click)="triggerCloseGeneratePeriods()">Cancel</button>
        <button class="btn btn-primary" (click)="generateForecast()" [disabled]="isSubmitting">
          <span class="build-statement-btn-label">Build Statement</span>
          @if (isSubmitting) {
            <div class="loader button-loader build-statement-btn-icon"></div>
          }
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="loading-panel-container loader__container">
    <div class="loader"></div>
  </div>
}
